// src/utils/apiFetch.js
import { ensureVisitorId } from '../utils/wishlistStorage' // już masz to u siebie
const API_BASE = process.env.GATSBY_API_URL || '/api'

export default function apiFetch(path, opts = {}) {
  const {
    includeVisitorId = true,
    ...restOpts
  } = opts

  const headers = {
    'Accept': 'application/json',
    ...(restOpts.body ? { 'Content-Type': 'application/json' } : {}),
    ...(includeVisitorId ? { 'x-visitor-id': ensureVisitorId() } : {}),
    ...(restOpts.headers || {}),
  }
  const final = {
    ...restOpts,
    headers,
    credentials: restOpts.credentials ?? 'include',
    ...(restOpts.body && typeof restOpts.body !== 'string'
      ? { body: JSON.stringify(restOpts.body) }
      : {}),
  }
  return fetch(API_BASE + path, final)
}
